import {
  Box,
  FormControl,
  FormHelperText,
  InputBase,
  InputBaseProps,
  InputLabel,
  Typography,
  styled
} from '@mui/material';
import { countryPhones } from 'constants/country-phones';
import { ChangeEvent, ReactNode, useRef, useState } from 'react';
import { ControllerRenderProps, FieldValues, useController } from 'react-hook-form';

interface Props extends Omit<InputBaseProps, 'label'> {
  label: string | ReactNode;
  hookForm?: ControllerRenderProps<FieldValues, string>;
}

export default function PhoneNumberInput({ label, onChange, hookForm, ...props }: Props) {
  const inputRef = useRef<HTMLInputElement>(null);
  const [selectedCountryCode] = useState(countryPhones[0].code);
  const { fieldState } = useController({ name: hookForm?.name ?? '' });

  const handleChangeInput = (event: ChangeEvent<HTMLInputElement>) => {
    onChange?.(event);
    hookForm?.onChange(`${selectedCountryCode}${event.target.value}`);
  };

  return (
    <Box sx={{ mb: 2 }}>
      <InputLabel shrink htmlFor={props.name} error={Boolean(fieldState.error?.message)}>
        {label}
      </InputLabel>
      <Box sx={{ display: 'flex', gap: 1, marginTop: 0.5 }}>
        <CountryCodeBox>
          <img
            src={countryPhones[0].icon}
            alt={countryPhones[0].code}
            width="21px"
            loading="lazy"
            style={{ border: '1px solid lightgrey', marginRight: 5 }}
          />
          <Typography>{countryPhones[0].code}</Typography>
        </CountryCodeBox>
        <FormControl fullWidth={props.fullWidth} error={Boolean(fieldState.error?.message)}>
          <InputBase
            id={props.name}
            {...props}
            sx={{ py: 0, ...props.sx }}
            onChange={handleChangeInput}
            inputRef={inputRef}
            value={hookForm?.value?.replace(selectedCountryCode, '')}
          />
        </FormControl>
      </Box>
      <FormHelperText sx={{ m: 0 }} error={Boolean(fieldState.error?.message)}>
        {fieldState.error?.message}
      </FormHelperText>
    </Box>
  );
}

const CountryCodeBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '90px',
  height: '42px',
  borderRadius: theme.spacing(0.5),
  border: `1px solid ${theme.palette.grey[300]}`,
  backgroundColor: theme.palette.background.paper
}));
